import React, { Component } from 'react';

class Embed extends Component {
  render() {
    const { src } = this.props;

    return (
      <iframe
        title="Webchat Iframe"
        width="100%"
        height={300}
        style={{ border: 0 }}
        loading="lazy"
        allowFullScreen
        src={src}
      />
    );
  }
}

export default Embed;



// WEBPACK FOOTER //
// ./src/components/MessageHistory/BotMessage/Embed.js